// FC-010: template-local frame-design discovery helpers.
//
// The Flash Cards decorative frame supports MULTIPLE designs stored as numbered PNGs
// under a human-authoritative public S3 prefix in bucket flink-2.0-fs. One design is
// chosen at random per activity open and held stable for the activity's lifetime.
//
// These helpers are PURE (parsing + picking) so they can be unit-tested without
// importing the React component (which transitively pulls in a barrel Jest cannot
// transform). The component composes them with fetch + state. No backend, no S3
// writes, no shared/config change — only reads of an already-public listing.

// Human-authoritative constants — NOT derived from imagesURL/REACT_APP_FILE_BUCKET,
// which may resolve to a different bucket/CDN.
export const FRAME_PREFIX = 'Images/TemplateGraphics/FlashCards/';
export const FRAME_PREFIX_URL =
  'https://s3.us-east-2.amazonaws.com/flink-2.0-fs/Images/TemplateGraphics/FlashCards/';
export const FRAME_LIST_URL =
  'https://s3.us-east-2.amazonaws.com/flink-2.0-fs?list-type=2&prefix=Images/TemplateGraphics/FlashCards/';
// Known-good single frame — retained as the seed/fallback (last-accepted asset).
export const FRAME_FALLBACK_URL =
  'https://s3.us-east-2.amazonaws.com/flink-2.0-fs/Images/FlinkPlay/FlashCard.png';

// Parse only DIRECT `flashcard<n>.png` children out of a list-objects-v2 XML body.
// <Key> values are full keys like `Images/TemplateGraphics/FlashCards/flashcard3.png`.
// Requires the basename to match `flashcard<digits>.png` (case-correct, lowercase)
// and rejects any key with a further `/` after the prefix (nested objects) or any
// unrelated / not-intended file.
export function parseFrameKeys(xmlText) {
  if (typeof xmlText !== 'string' || !xmlText) return [];
  const keys = [];
  const re = /<Key>([^<]+)<\/Key>/g;
  let m;
  while ((m = re.exec(xmlText)) !== null) {
    const key = m[1];
    if (key.indexOf(FRAME_PREFIX) !== 0) continue;
    const rest = key.slice(FRAME_PREFIX.length);
    if (!rest || rest.indexOf('/') !== -1) continue; // direct children only
    if (/^flashcard\d+\.png$/.test(rest)) keys.push(rest);
  }
  return keys;
}

// Pick one design name at random. `rand` is injectable for deterministic tests
// (defaults to Math.random). Returns null when there is nothing to choose.
export function pickFrameName(names, rand = Math.random) {
  if (!Array.isArray(names) || names.length === 0) return null;
  const i = Math.floor(rand() * names.length);
  const clamped = Math.min(Math.max(i, 0), names.length - 1);
  return names[clamped];
}

// Build a full design URL from a chosen basename.
export function frameUrlFor(name) {
  return FRAME_PREFIX_URL + name;
}
